import { render, staticRenderFns } from "./ChargeLegacyOrder.vue?vue&type=template&id=23b19f3e"
import script from "./ChargeLegacyOrder.vue?vue&type=script&lang=js"
export * from "./ChargeLegacyOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports